module.exports = __webpack_public_path__ + "static/media/jackpot-diamond.74755fdd.svg";